var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPinOrangeHollow = function SvgPinOrangeHollow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 30,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pin-orange-hollow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.998.5C18.545.5 23.5 5.632 23.496 12.499v.001c0 4.29-2.681 8.432-5.51 11.592-2.813 3.142-5.686 5.221-5.91 5.383h-.002a.126.126 0 0 1-.076.025.128.128 0 0 1-.077-.024l-.001-.001c-.227-.164-3.1-2.242-5.911-5.383C3.18 20.932.5 16.79.5 12.5.5 5.632 5.456.5 11.998.5Zm0 4.005c-4.098 0-7.445 3.304-7.445 7.373 0 4.069 3.342 7.374 7.445 7.374 4.098 0 7.444-3.305 7.444-7.374 0-4.069-3.346-7.373-7.444-7.373Z",
    stroke: "#F39237"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pin-orange-hollow_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v30H0z"
  })))));
};

export default SvgPinOrangeHollow;